const CartType = {
  None: 'None',
  Shop: 'Shop',
  Quote: 'Quote'
};

export default CartType;
